import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "q-ma-none" }, "Påställ", -1)
const _hoisted_2 = { class: "row q-col-gutter-md" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Bekräfta fordon påställt", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-8 q-pb-md" }
const _hoisted_7 = { class: "col-4 q-pb-md" }
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "col-12 q-pb-md" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Avställningar med samma tågsätt", -1)
const _hoisted_11 = { class: "col-auto" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row q-col-gutter-md" }
const _hoisted_14 = {
  key: 0,
  class: "col-12"
}
const _hoisted_15 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-grey-8" }, " Använda artiklar och komponenter är helt i enlighet med godkänd reservdelslista. ", -1)
const _hoisted_17 = {
  key: 1,
  class: "col-12"
}
const _hoisted_18 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-grey-8" }, " Samtliga förebyggande och avhjälpande underhåll är utförda i enlighet med godkänd dokumentation i Catalog Creator eller på FTP-server. ", -1)
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-caption text-grey-8" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "q-pl-lg" }, [
    /*#__PURE__*/_createElementVNode("li", null, " Fordonet får inte vara försett med säkerhetskritiska eller stoppande fel* "),
    /*#__PURE__*/_createElementVNode("li", null, " Samtliga förebyggande underhåll ska vara utfört och kvitterat i underhållssystemet. "),
    /*#__PURE__*/_createElementVNode("li", null, " Avhjälpande underhåll ska vara utfört till den största omfattning som är möjligt. Eventuella kvarvarande fel får inte vara av stoppande eller säkerhetskritisk karaktär och ska tydligt vara inskrivna i underhållssystemet med öppen(ej åtgärdad) status. ")
  ])
], -1)
const _hoisted_23 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_AppFieldDate = _resolveComponent("AppFieldDate")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": true,
    onHide: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        square: "",
        style: {"width":"800px","max-width":"800px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            ref: "formRef",
            onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
            autocomplete: "off",
            greedy: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_AppFieldDate, {
                            outlined: "",
                            label: "Påställ",
                            modelValue: _ctx.readyDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.readyDate) = $event)),
                            rules: [_ctx.validDateRule]
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_q_input, {
                            outlined: "",
                            square: "",
                            type: "time",
                            modelValue: _ctx.readyTime,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.readyTime) = $event)),
                            rules: [_ctx.requiredRule]
                          }, null, 8, ["modelValue", "rules"])
                        ])
                      ]),
                      (_ctx.isReasonAU)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_q_input, {
                                outlined: "",
                                square: "",
                                label: "Workorder",
                                modelValue: _ctx.workorder,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.workorder) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_10,
                      _createVNode(_component_q_list, { bordered: "" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleWithdrawalsSameComposition, (vehicleWithdrawal, $i) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              tag: "label",
                              key: $i
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, {
                                  side: "",
                                  top: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_checkbox, {
                                      modelValue: _ctx.selectedVehicleWithdrawlUuids,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedVehicleWithdrawlUuids) = $event)),
                                      val: vehicleWithdrawal.uuid
                                    }, null, 8, ["modelValue", "val"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(vehicleWithdrawal.vehicle.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_q_item_label, { caption: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Avställd: " + _toDisplayString(_ctx.formatDate(vehicleWithdrawal.withdrawn)) + " - " + _toDisplayString(vehicleWithdrawal.vehicleWithdrawalDepot), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)), [
                              [_directive_ripple]
                            ])
                          }), 128)),
                          _createVNode(_component_q_separator)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_q_separator, {
                        vertical: "",
                        style: {"height":"100%"}
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (
                    _ctx.vehicleWithdrawalsSameComposition
                      .map((x) => x.vehicle.vehicle_type.name)
                      .includes('X15p')
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_q_checkbox, {
                                style: {"margin-left":"-6px"},
                                modelValue: _ctx.confirmX15PCheckoutFirst,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmX15PCheckoutFirst) = $event)),
                                label: "Gäller för X15P"
                              }, null, 8, ["modelValue"]),
                              (_ctx.showConfirmCheckoutError)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Obligatorisk "))
                                : _createCommentVNode("", true),
                              _hoisted_16
                            ]))
                          : _createCommentVNode("", true),
                        (
                    _ctx.vehicleWithdrawalsSameComposition
                      .map((x) => x.vehicle.vehicle_type.name)
                      .includes('X15p')
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_q_checkbox, {
                                style: {"margin-left":"-6px"},
                                modelValue: _ctx.confirmX15PCheckoutSecond,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmX15PCheckoutSecond) = $event)),
                                label: "Gäller för X15P"
                              }, null, 8, ["modelValue"]),
                              (_ctx.showConfirmCheckoutError)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Obligatorisk "))
                                : _createCommentVNode("", true),
                              _hoisted_19
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_q_checkbox, {
                            style: {"margin-left":"-6px"},
                            modelValue: _ctx.confirmCheckout,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmCheckout) = $event)),
                            label: "Bekräfta utcheckning av fordon"
                          }, null, 8, ["modelValue"]),
                          (_ctx.showConfirmCheckoutError)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Obligatorisk "))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.readyComment,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.readyComment) = $event)),
                            square: "",
                            outlined: "",
                            autogrow: "",
                            label: "Påställningskommentar",
                            type: "textarea",
                            rules: _ctx.confirmCheckout ? [] : [_ctx.requiredRule]
                          }, null, 8, ["modelValue", "rules"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_actions, { align: "right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    label: "Stäng",
                    onClick: _ctx.closeModal,
                    disable: _ctx.pending
                  }, null, 8, ["onClick", "disable"]),
                  _createVNode(_component_q_btn, {
                    label: "Bekräfta",
                    color: "white",
                    class: "text-red",
                    type: "submit",
                    disable: !_ctx.selectedVehicleWithdrawlUuids.length,
                    loading: _ctx.pending
                  }, null, 8, ["disable", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}